import React from "react";
import { useSelector } from "react-redux";
import { CloseHoc, SearchHoc } from "../../../assets/images";
import CustomIcon from "../../../assets/images/CustomIcon";
const RecentSearch = (props = {}) => {
    const {search = () => {}} = props;
  const [searchValue, setSearchValue] = React.useState("");
  const globalState = useSelector(state => state)
  const {
    mf_Search,mf_Close
    }=globalState?.dynamicIcon?.data

  const searchFilterList = (e) => {
    const { value } = e.target;
    if (value.trim().length === 0) {
      setSearchValue(value);
      search("");
    } else {
      setSearchValue(value);
      search(value);
    }
  };

  const resetInputField = () => {
    setSearchValue("");
    search("");
  };

  return (
    <div className="search">
      <input
        type="text"
        className="search-contacts"
        name="search-contacts"
        autoComplete="off"
        placeholder="Search"
        value={searchValue}
        onChange={searchFilterList}
      />
      <i className=""> {!searchValue &&   <CustomIcon icon={mf_Search ? mf_Search : <SearchHoc viewBox="0 0 14.201 14" />} {...props} />}</i>
      <i className="" onClick={resetInputField}>
        {searchValue &&   <CustomIcon icon={mf_Close ? mf_Close : <CloseHoc viewBox="0 0 12 12"/>} {...props} />
}
      </i>
    </div>
  );
};

export default RecentSearch;
